import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./motion";
import { IMAGES } from "../assets";

export const Confianza = () => {
  const { t } = useLang();
  return (
    <section id="trust" className="relative py-24 md:py-32 scroll-mt-24" data-testid="trust">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <Reveal>
            <div className="relative rounded-[2rem] overflow-hidden h-[380px] md:h-[520px] shadow-[0_24px_50px_rgb(3,33,42,0.12)]">
              <img src={IMAGES.client} alt="Personas ayudando a personas en casa" className="w-full h-full object-cover" data-testid="trust-image" />
              <div className="absolute inset-0 bg-gradient-to-t from-sage-deep/20 to-transparent" />
            </div>
          </Reveal>
          <div>
            <Reveal><span className="text-xs font-semibold uppercase tracking-[0.2em] text-forest">{t.trust.eyebrow}</span></Reveal>
            <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-5xl font-light tracking-tight text-ink leading-[1.1]">{t.trust.title}</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-lg md:text-xl text-ink-soft leading-relaxed">{t.trust.body}</p></Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
